import Content from "./Content";
import Header from "../../common/Popup/Header";
import { Modal, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const customStyles = {
  modal: {
    width: "850px",
    maxWidth: "95%",
    position: "absolute",
    height: "fit-content",
    display: "flex",
    flexDirection: "column",
    outline: "none",
  },
};

interface IStudentDetailsProps {
  open: boolean;
  onClose(): void;
}
function AddClassesDetails({ open, onClose }: IStudentDetailsProps) {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Typography component="div" sx={customStyles.modal}>
        <Header onClose={onClose} title={t("Adding classes")} />
        <Content onSubmit={onClose} />
      </Typography>
    </Modal>
  );
}

export default AddClassesDetails;
